import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Styles from './Modal.scss';

const ModalBody = (props) => {
    const { children, className } = props;

    return <div className={cx(Styles.modalBody, className)}>{children}</div>;
};

ModalBody.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
};
export default ModalBody;
